<template>
  <div class="container">
    <div class="search">
      <el-input
        :placeholder="$t('search.placeholderName')"
        v-model="keywords"
      ></el-input>
      <div class="button" @click="search()">{{ $t("common.search") }}</div>
    </div>

    <div class="mainContent">
      <div class="rightContent" v-if="lists.length > 0">
        <div
          v-for="(item, k) in lists"
          :key="k"
          class="content"
          @click="goDetail(item.obj.id)"
        >
          <div class="vedio1">
            <div class="titleLogo">
              <img
                :src="baseUrl + item.obj.comCover"
                alt=""
                v-if="item.obj.comCover.includes('/hz/hzupload')"
              />
              <img src="../../../static/占位-展商-列表.png" alt="" v-else />
            </div>
            <div class="main">
              <div class="company">{{ item.obj.companyNameC }}</div>
              <div class="box">
                <div class="zhanWeiNo">{{ $t("common.boothNum") }}</div>
                <div class="number">{{ item.obj.hzBoothList[0].boothNum }}</div>
              </div>
            </div>
          </div>

          <div class="bottom">
            <div class="bottomLeft" @click.stop="consult(item.obj.id)">
              {{ $t("collected.consult") }}
            </div>
            <div class="bottomRight" @click.stop="delItem(item.id)">
              <img src="../../../static/icon_del.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div class="boxImg" v-else>
        <img src="../../../static/empty.png" alt="" />
        <div>{{ $t("search.nocCollect") }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getExLists, delCollect } from "../../../../api/collection.js";
import { forMat, backExhibitorDetail } from "../../../../utils/common.js";

export default {
  data() {
    return {
      baseUrl: forMat(),
      type: "",
      keywords: "",
      lists: [],
      exhibitorDetailUrl: backExhibitorDetail(),
    };
  },
  created() {
    const params = {
      keyword: this.keywords,
    };
    this.getLists(params);
  },
  methods: {
    consult(id) {
      this.$router.push({
        name: "messageDetail",
        query: {
          receiveUserId: id,
        },
      });
    },
    goDetail(id) {
      window.location.href = this.exhibitorDetailUrl + "?id=" + id;
    },
    async getLists(params) {
      try {
        const { data } = await getExLists(params);
        if (data.code === 200) {
          this.lists = data.data;
          console.log("***********", this.lists);
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    search() {
      // 搜索函数 type keywords
      const params = {
        keyword: this.keywords,
      };
      this.getLists(params);
    },
    async delItem(id) {
      const params1 = {
        id: id,
      };
      try {
        const { data } = await delCollect(params1);
        if (data.code === 200) {
          const params = {
            keyword: this.keywords,
          };
          this.getLists(params);
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 176px);
  background-color: white;
  padding-top: 15px;

  .search {
    display: flex;
    padding: 0px 15px;
    box-sizing: border-box;
    .button {
      width: 100%;
      height: 36px;
      background: #006fb8;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 36px;
      text-align: center;
      margin-left: 10px;
    }
  }
  .mainContent {
    .rightContent {
      display: grid;
      grid-template-columns: repeat(2,48%);
      justify-content: space-between;
      padding: 0px 15px;
      box-sizing: border-box;
      margin-top: 20px;
          grid-column-gap: 10px;
    grid-row-gap: 10px;
      .content {
        background-color: #ffffff;
        border: 1px solid #e0e0e0;
     
        cursor: pointer;

        .vedio1 {
          position: relative;
          padding-top: 47px;
          .titleLogo {
            background: #ffffff;
            box-shadow: 0px 0px 51px 0px #e8ecf0;
            position: absolute;
            top: 10px;
            left: 0px;
            right: 0px;
            margin: auto;

            width: 138px;
            height: 60px;
            justify-content: center;
            align-items: center;
            display: flex;

            img {
              max-width: 100%;
              max-height: 100%;
            }
          }
          .main {
            width: 100%;
            background: #ebf7ff;
            padding-top: 33px;
            .company {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 600;
              color: #333333;
              line-height: 20px;
              text-align: center;
              padding: 0px 9px;
              box-sizing: border-box;
              padding-bottom: 11px;
              height: 42px;

              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            .box {
              display: flex;
              justify-content: center;
              align-items: center;
              padding-bottom: 11px;
              //展位号
              span {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 17px;
              }
              .zhanWeiNo {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 17px;
              }
              //数字展位号
              .number {
                font-size: 14px;
                font-family: Arial-BoldMT, Arial;
                font-weight: 600;
                color: #333333;
                line-height: 16px;
              }
            }
          }
        }

        .bottom {
          padding: 10px 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .bottomLeft {
            cursor: pointer;
            flex: 1;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #006fb8;
            line-height: 17px;
          }
          .bottomRight {
            width: 16px;
            height: 16px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 16px;
              height: 16px;
            }
          }
        }
      }
    }
  }
}
</style>
<style scoped>
.el-cascader {
  line-height: 32px;
}
.el-input {
  width: 240px;
  height: 36px;
}
.container >>> .el-input__inner {
  width: 240px;
  height: 36px;
  line-height: 36px;
}
.container >>> .el-input__icon {
  line-height: 36px;
}
</style>
<style lang="scss" scoped>
.boxImg {
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  img {
    width: 220px;
    height: 180px;
    margin: 0 auto;
  }
}
</style>
